module.exports = {
	"LANGUAGE": "Langue",
	"HDR-obpa_fulltext_score": "Pointage",
	"HDR-obpa_name": "Nom",
	"HDR-obpa_fulltext_summary": "Résumé",
	"QUERY LIMIT REACHED": "Il y a plus de résultats que ce qui est affiché. Veuillez préciser vos critères de recherche.",
	"NO DOCUMENTS FOUND": "Aucun document trouvé.",
	"OPEN IN NEW WINDOW": "Ouvrir dans nouvelle fenêtre",
	"DOWNLOAD NATIVE": "Télécharger en format natif",
	"CLOSE": "Fermer",
	"SEARCH TYPE": "Type de recherche",
	"DOCUMENT TYPE": "Type de document",
	"SEARCH TERM": "Terme de recherche",
	"SEARCH": "Rechercher",
	"RESET": "Rétablir",
	"DATE": "Date",
	"FROM DATE": "Date de début",
	"TO DATE": "Date finale",
	"LOADING": "Chargement...",
	"RETRY": "Réessayer",
	"ERROR": "Erreur !",
	"ERROR: QUERIES": "Impossible de récupérer la liste des types de recherche.",
	"ERROR: DOCTYPES": "Impossible de récupérer la liste des types de documents.",
	"ERROR: KEYWORDS": "Impossible de récupérer la liste des champs de recherche.",
	"ERROR: DOCUMENTS": "Impossible d'effectuer la recherche demandée.",
	"FORM: INVALID FULLTEXT": "Le champ doit comporter au moins {{chars}} caractères.",
	"FORM: INVALID DATE SHORT": "Formater: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Le champ est obligatoire.",
	"FORM: INVALID NUMERIC": "Le champ doit comporter jusqu'à {{digits}} chiffres.",
	"FORM: INVALID DATE": "Le champ doit suivre le format {{format}} .",
	"FORM: INVALID CURRENCY": "La zone doit être une valeur de devise valable.",
	"FORM: INVALID FLOAT": "Le champ doit être un nombre.",
	"FORM: INVALID LENGTH": "Le champ doit comporter au maximum {{chars}} caractères.",
	"FORM: ERRORS": "Il y a des erreurs sur le formulaire.",
	"FORM: noDate": "Une plage de dates doit être spécifiée.",
	"FORM: noKeyword": "Au moins un champ doit être spécifié.",
	"FORM: noDateOrKeyword": "Une plage de dates OU au moins une zone doit être spécifiée.",
	"FORM: noDateAndKeyword": "Une plage de dates ET au moins une zone doit être spécifiée."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/fr.json
// module id = 354
// module chunks = 0